import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useCreatorPostStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: "flex",
      flexDirection: "column",
      // padding: "25px 12px 40px 40px",
      maxWidth: "100%",
      overflowX: "hidden",
      [theme.breakpoints.down("md")]: {
        // padding: "25px 12px 40px 0px",
      },
      [theme.breakpoints.down("sm")]: {
        // padding: "8px 8px 40px 8px",
      },
      "&.explore": {
        [theme.breakpoints.down("md")]: {},
        [theme.breakpoints.down("sm")]: {},
        [theme.breakpoints.down("xs")]: {
          display: "flex",
          // padding: "15px 50px 20px 10px",

          //   alignItems: "center",
        },
        [theme.breakpoints.up("lg")]: {},
      },
    },
    root: {
      border: "1px solid #1F1F1F",
      borderRadius: 16,
      overflow: "hidden",
      backgroundColor: "#131313",
      color: "#fff",
      width: "100%",
      //  maxWidth: 600,
      margin: "0 auto 32px",
      position: "relative",
      paddingBottom: "12px",
      [theme.breakpoints.down("md")]: {
        padding: 0,
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: 16,
      },
      [theme.breakpoints.down("sm")]: {
        padding: "12px",
        borderRadius: 12,
      },
      [theme.breakpoints.down("xs")]: {
        padding: theme.spacing(1),
      },
      [theme.breakpoints.up("lg")]: {},
      "&.MyFeed": {
        border: "1px solid #1F1F1F",
        borderRadius: 16,
        overflow: "hidden",
        backgroundColor: "#131313",
        color: "#fff",
        width: "100%",
        maxWidth: 600,
        margin: "0 auto 40px",
        [theme.breakpoints.down("md")]: {
          marginLeft: "auto",
          marginRight: "auto",
          borderRadius: 16,
        },
        [theme.breakpoints.down("sm")]: {
          borderRadius: 12,
        },
        [theme.breakpoints.down("xs")]: {},
        [theme.breakpoints.up("lg")]: {
          maxWidth: "60vw",
        },
      },
      "&.explore": {
        border: "none",
        borderRadius: 20,
        backgroundColor: "#000000",
        display: "flex",
        flexDirection: "column",
        padding: "0px",
        marginLeft: "none",
        marginRight: "none",
        overflow: "visible",
        maxWidth: 600,
        [theme.breakpoints.down("md")]: {
          maxWidth: 500,
        },
        [theme.breakpoints.down("sm")]: {},
        [theme.breakpoints.down("xs")]: {
          // maxWidth: 320,
          minWidth: 300,
          marginLeft: "0px",
          marginRight: "0px",
          //   padding: "25px px 40px 10px",
          //   paddingRight: "30px",
        },
        [theme.breakpoints.up("lg")]: {},
      },
    },
    cardContainer: {
      padding: "24px 24px 0px 24px ",
      [theme.breakpoints.down("sm")]: {
        padding: "8px",
      },
    },
    header: {
      padding: "0 0 24px 0",
      "& .MuiCardHeader-title": {
        color: "#fff",
        fontWeight: 600,
      },
      "& .MuiCardHeader-action": {
        margin: "auto 0",
        "& .MuiIconButton-root": {
          padding: 0,
        },
      },
      [theme.breakpoints.down("sm")]: {
        padding: "0 0 16px 0",
      },
      "&.explore": {
        padding: "10px 15px",
        bottom: 40,
        left: 3,
      },
    },

    avatar: {
      width: 75,
      height: 75,
      backgroundColor: "#333",
      marginRight: "12px",
      "&.explore": {
        border: "2px solid #FE5A97",
        width: 70,
        height: 70,
      },
      [theme.breakpoints.down("sm")]: {
        width: 48,
        height: 48,
        marginRight: "8px",
      },
    },
    verifiedIcon: {
      color: "#FE5A97",
    },
    username: {
      fontSize: "21px",
      fontWeight: 700,
      color: "#FE5A97", // Колір #FE5A97 для всіх розмірів
      textDecoration: "none", // Прибираємо стандартне підкреслення
      "&.explore": {
        color: "#FE5A97", // Колір #FE5A97 для всіх розмірів
        fontSize: "12px",
        fontWeight: 600,

        "&:hover": {
          textDecoration: "none",
          // Змінюємо колір на рожевий при наведенні
        },
        [theme.breakpoints.down("sm")]: {
          fontSize: "12px", // 12px на мобільних
        },
      },
      [theme.breakpoints.down("md")]: {},
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px", // 12px на мобільних
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: "12px", // 12px на мобільних
      },
      [theme.breakpoints.up("lg")]: {},
    },
    nameUserLastName: {
      minWidth: "119px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    firstLastNameHelp: {
      fontSize: "17px",
      fontWeight: 700,
      color: "#FFFFFF",
      textDecoration: "none", // Прибираємо стандартне підкреслення
      "&.explore": {
        "&:hover": {
          textDecoration: "none",
          cursor: "pointer",
          color: "#FE5A97", // Змінюємо колір на рожевий при наведенні
        },
        [theme.breakpoints.down("sm")]: {
          fontSize: "16px", // 16px на мобільних
        },
      },
      [theme.breakpoints.down("md")]: {},
      [theme.breakpoints.down("sm")]: {
        fontSize: "16px", // 16px на мобільних
      },
      [theme.breakpoints.down("xs")]: {
        fontSize: "16px", // 16px на мобільних
      },
      [theme.breakpoints.up("lg")]: {},
    },
    sliderStyle: {
      width: "100%",
      marginLeft: 0,
      [theme.breakpoints.down("sm")]: {},
      [theme.breakpoints.down(400)]: {},
    },

    "@global": {
      ".slick-slide": {
        display: "block",
        boxSizing: "border-box",
      },
      ".slick-slide > div": {
        height: "auto",
      },
      ".slick-track": {
        display: "block",
        alignItems: "stretch",
      },
      ".slick-list": {
        overflow: "hidden",
      },
      // dots styling: default and active
      ".slick-dots li": {
        margin: "0 1px", // spacing between dots
      },
      ".slick-dots li button:before": {
        color: "#888", // default dot color
      },
      ".slick-dots li.slick-active button:before": {
        color: "#FE5A97", // pink color for active dot
      },
      ".explore .MuiCardHeader-avatar": {
        marginRight: "1px !important",
      },
      ".MuiCardHeader-avatar": {
        marginRight: "0 !important", // Видаляємо margin-right
      },
    },

    //   "@global": {
    //     ".explore .MuiCardHeader-avatar": {
    //       marginRight: "1px !important", // Перевизначаємо margin-right
    //     },
    //   },
    mediaContainer: {
      width: "100%",
      margin: "0 auto",
      padding: 0,
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down("md")]: {
        //     maxHeight: 400,
      },
      [theme.breakpoints.down("sm")]: {
        marginBottom: theme.spacing(1),
      },
      "&.My Subscription": {
        maxHeight: 500,
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
          maxHeight: 400,
        },
        [theme.breakpoints.down("sm")]: {},
      },
      "&.explore": {
        height: "100%",
        width: "100%",
        flexGrow: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        [theme.breakpoints.down("md")]: {},
        [theme.breakpoints.down("sm")]: {},
        [theme.breakpoints.down("xs")]: {},
        [theme.breakpoints.up("lg")]: {},
      },
    },
    mediaContainerLikesBookmarks: {
      backgroundColor: "#0a0a0a",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "500px",
      [theme.breakpoints.down("md")]: {
        minHeight: "400px",
      },
      [theme.breakpoints.down("sm")]: {
        minHeight: "350px",
      },
    },
    media_img: {
      width: "100%",
      objectFit: "contain",
      height: "auto",
      borderRadius: 12,
      [theme.breakpoints.down("md")]: {
        height: "auto",
      },
      [theme.breakpoints.down("sm")]: {
        height: "auto",
      },
      "&.MyFeed": {
        [theme.breakpoints.down("md")]: {},
        [theme.breakpoints.down("sm")]: {},
      },
      "&.preview": {
        objectFit: "contain",
        backgroundColor: "#0a0a0a",
      },
      "&.likesBookmarks": {
        objectFit: "contain",
        backgroundColor: "#0a0a0a",
        [theme.breakpoints.down("md")]: {},
        [theme.breakpoints.down("sm")]: {},
      },
      "&.explore": {
        height: "auto",
        maxHeight: "710px",
        borderRadius: 22,
        [theme.breakpoints.down("md")]: {},
        [theme.breakpoints.down("sm")]: {},
        [theme.breakpoints.down("xs")]: {},
        [theme.breakpoints.up("lg")]: {},
      },
    },
    media_video: {
      width: "100%",
      borderRadius: theme.shape.borderRadius,
      height: "auto",
      objectFit: "contain",
      "&::-webkit-media-controls-overflow-button": {
        display: "none !important",
      },
      "&::-webkit-media-controls-menu-button": {
        display: "none !important",
      },
      [theme.breakpoints.down("md")]: {
        height: "auto",
      },
      [theme.breakpoints.down("sm")]: {
        height: "auto",
      },
      "&.MyFeed": {
        objectFit: "cover",
        [theme.breakpoints.down("md")]: {},
        [theme.breakpoints.down("sm")]: {},
      },
      "&.preview": {
        objectFit: "contain",
        backgroundColor: "#0a0a0a",
      },
      "&.likesBookmarks": {
        objectFit: "contain",
        backgroundColor: "#0a0a0a",
        [theme.breakpoints.down("md")]: {},
        [theme.breakpoints.down("sm")]: {},
      },
      "&.explore": {
        height: "auto",
        maxHeight: "710px",
        borderRadius: 22,
        [theme.breakpoints.down("md")]: {},
        [theme.breakpoints.down("sm")]: {},
        [theme.breakpoints.down("xs")]: {},
        [theme.breakpoints.up("lg")]: {},
      },
    },
    statsContainer: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: theme.spacing(2),
      padding: "10px 0 10px",
      //   padding: theme.spacing(0, 2, 0, 2),
      [theme.breakpoints.down("sm")]: {
        justifyContent: "space-between",
        gap: theme.spacing(1),
      },
      "&.explore": {
        flexDirection: "column",
        alignItems: "centre",
        position: "absolute",
        right: "20px",
        bottom: 30,
        gap: theme.spacing(1),
        [theme.breakpoints.down("md")]: {},
        [theme.breakpoints.down("sm")]: {
          right: -5,
        },
        [theme.breakpoints.down("xs")]: {
          padding: 0,
          right: -5,
        },
        [theme.breakpoints.up("lg")]: {},
      },
    },
    stat: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(0.5),
      color: "#fff",
      fontSize: "14px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "13px",
      },
      "&.explore": {
        flexDirection: "column",
        justifyContent: "flex-end",
      },
    },
    tipButton: {
      display: "flex",
      marginLeft: theme.spacing(2),
      border: "1px solid #FE5A97",
      color: "#FE5A97",
      padding: theme.spacing(0.5, 2),
      textTransform: "none",
      fontWeight: 600,
      fontSize: "14px",
      whiteSpace: "nowrap",
      [theme.breakpoints.down("sm")]: {
        marginLeft: 0,
        padding: "6px 12px",
        fontSize: "12px",
        width: "100%",
        justifyContent: "center",
      },
    },
    followButton: {
      display: "flex",
      border: "1px solid #FE5A97",
      color: "#FE5A97",
      padding: theme.spacing(0.5, 2),
      textTransform: "none",
      fontWeight: 600,
      fontSize: "14px",
      whiteSpace: "nowrap",
      [theme.breakpoints.down("sm")]: {
        padding: "6px 12px",
        fontSize: "12px",
        width: "100%",
        justifyContent: "center",
      },
      "&.explore": {
        height: "30px",
        width: "70px",
        border: "1px solid #FFFFFF",
        color: "#FFFFFF",
      },
    },
    zxc: {
      padding: "20px 0 0 20px",
    },
    description: {
      padding: theme.spacing(0, 2, 1, 2),
      color: "#ccc",
      fontSize: "16px", // Базовий розмір для десктопу
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(0, 1, 1, 1),
        fontSize: "12px", // 12px на мобільних
      },
      "&.explore": {
        padding: "8px 15px 0 0",
        position: "relative",
        bottom: "auto",
        left: "auto",
        fontSize: "16px",
        color: "#FFFFFF",
        textAlign: "center",
        [theme.breakpoints.down("sm")]: {
          fontSize: "12px", // 12px на мобільних
          padding: "6px 10px 0 0",
        },
      },
      "&.feedOverlay": {
        padding: "8px 12px",
        fontSize: "16px", // Базовий розмір для десктопу
        [theme.breakpoints.down("sm")]: {
          fontSize: "12px", // 12px на мобільних
          padding: "6px 0",
        },
        // background:
        //   "linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0) 50%, rgba(0,0,0,1) 100%)",
        // borderBottomLeftRadius: 12,
        // borderBottomRightRadius: 12,
      },
    },
    BotsstatsContainer: {
      [theme.breakpoints.down("sm")]: {},
      "&.explore": {
        left: 0,
        bottom: 40,
        position: "absolute",
        display: "flex",
        [theme.breakpoints.down("sm")]: {
          bottom: 20,
        },
      },
    },
    BotssttatsContainer: {
      [theme.breakpoints.down("sm")]: {},
      "&.explore": {
        left: 0,
        bottom: 40,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        marginBottom: "16px", // Тільки для десктопу
        [theme.breakpoints.down("sm")]: {
          bottom: 45,
          marginBottom: 0, // Видаляємо для мобільних
        },
      },
    },
    hashtags: {
      fontSize: "16px",
      fontWeight: 400,
      color: "#FFFFFF",
      padding: "4px 8px",
      borderRadius: "12px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px", // 12px на мобільних
        padding: "4px 4px",
      },
    },
    commentSection: {
      padding: theme.spacing(1, 2, 2, 2),
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(1),
      },
      "&.explore": {
        padding: "10px 15px",
        position: "absolute",
        bottom: 10,
        left: 10,
        width: "70%",
      },
    },
    commentInput: {
      display: "flex",
      alignItems: "center",
      backgroundColor: "#1e1e1e",
      borderRadius: 24,
      padding: theme.spacing(1, 2),
      "& .MuiInputBase-root": {
        color: "#fff",
      },
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(0.5, 1.5),
      },
    },
    showAllCommentsButton: {
      "&:hover": {
        color: "#0095f6",
      },
      color: "#777",
      marginTop: 8,
      cursor: "pointer",
      fontSize: "16px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "13px",
      },
    },
    stats: {
      fontSize: "14px",
      fontWeight: 600,
      color: "#FFFFFF",
      [theme.breakpoints.down("md")]: {
        padding: 0,
      },
      "&.explore": {
        "& .MuiIconButton-label": {
          display: "flex",
          flexDirection: "column",
        },
        [theme.breakpoints.down("md")]: {},
        [theme.breakpoints.down("sm")]: {},
        [theme.breakpoints.down("xs")]: {
          fontSize: "7px",
          fontWeight: 400,
        },
        [theme.breakpoints.up("lg")]: {},
      },
    },
    statss: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 600,
      color: "#FFFFFF",
      "&.explore": {
        "& .MuiIconButton-label": {
          display: "flex",
          flexDirection: "column",
        },
        [theme.breakpoints.down("md")]: {},
        [theme.breakpoints.down("sm")]: {},
        [theme.breakpoints.down("xs")]: {
          fontSize: "7px",
          fontWeight: 400,
        },
        [theme.breakpoints.up("lg")]: {},
      },
    },
    statsButton: {
      display: "flex",
      alignItems: "center",
      textTransform: "none",
    },
    statsTip: {
      fontSize: "14px",
      fontWeight: 500,
      color: "#FE5A97",
      marginLeft: "5px",
    },
    statsActions: {
      marginLeft: "215px",
    },
    modelSubscriptionWrapper: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#131313",
      padding: "0px",
      width: "500px",
      borderRadius: "16px",
      zIndex: 1401, // має бути вищий за overlay
      boxShadow: "0px 4px 20px rgba(0,0,0,0.5)",
      border: "1px solid #363636",
      [theme.breakpoints.down("sm")]: {
        width: "90%",
        margin: "0 auto",
        maxHeight: "90vh",
        overflow: "auto",
      },
    },
    modalTipWrapper: {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#131313",
      padding: "0px",
      width: "500px",
      borderRadius: "16px",
      zIndex: 1401, // має бути вищий за overlay
      boxShadow: "0px 4px 20px rgba(0,0,0,0.5)",
      border: "1px solid #363636",
      [theme.breakpoints.down("sm")]: {
        width: "90%",
      },
    },
    modalActions: {
      backgroundColor: "#131313",
      borderTop: "1px solid #363636",
      padding: "16px",
      justifyContent: "space-between",
    },

    cancelButton: {
      color: "#fff",
      backgroundColor: "#333",
      "&:hover": {
        backgroundColor: "#444",
      },
    },

    sendButton: {
      color: "#fff",
      backgroundColor: "#FE5A97",
      "&:hover": {
        backgroundColor: "#E5497F",
      },
    },

    unlockedLabel: {
      position: "absolute",
      top: "3%",
      left: "75%",
      // transform: "translateX(-50%)",
      zIndex: 4,
      padding: "0px",
      color: "#FE5A97",
      border: "2px solid #FE5A97",
      borderRadius: "5px",
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "12px",
      textTransform: "none",
      width: "65px",
      [theme.breakpoints.down("sm")]: {
        height: "30px",
        left: "73%",
        width: "30px",
        minWidth: "30px",
        fontSize: "9px",
        fontWeight: 700,
        top: "1%",
      },
    },
    modalTitle: {
      backgroundColor: "#131313",
      color: "#FE5A97",
      textAlign: "center",
      fontSize: "24px",
      padding: "20px 0",
      borderBottom: "1px solid #363636",
    },
    modalContent: {
      backgroundColor: "#131313",
      color: "#fff",
      padding: "24px",
    },
    nameHelp: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      gap: "2px",
      [theme.breakpoints.down("sm")]: {
        gap: "0px",
      },
    },
    firstLastName: {
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: 1.5,
      "&:hover": {
        cursor: "pointer",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "16px", // 16px на мобільних
        fontWeight: 450,
        lineHeight: "17px",
      },
    },
    usersName: {
      fontSize: "14px",
      fontWeight: 600,
      color: "#FF78AA", // Колір #FF78AA для всіх розмірів
      marginLeft: 0,
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px", // 12px на мобільних
        fontWeight: 350,
        marginLeft: 0,
      },
    },

    modalSubtitle: {
      fontSize: "16px",
      marginBottom: "16px",
      lineHeight: "1.5",
      textAlign: "center",
    },
    tipInputContainer: {
      marginTop: "8px",
    },

    tipLabel: {
      marginBottom: "8px",
      fontSize: "14px",
    },

    tipInput: {
      "& input": {
        color: "#fff",
        backgroundColor: "#1e1e1e",
        MozAppearance: "textfield", // Firefox
      },
      "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
      },
      // Вимикає стрілки в Chrome/Safari
      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
        {
          WebkitAppearance: "none",
          margin: 0,
        },
    },
    modalSubscriptionWrapper: {},
    nameLink: {
      textDecoration: "none",
      color: "inherit",
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      "&:hover": {
        textDecoration: "none",
        color: "inherit",
        cursor: "pointer",
      },
    },

    mediaHelpmedia: {
      width: "695px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        width: "380px",
      },
    },
    rootHelpHelp: {
      border: "1px solid #363636",
      borderRadius: 16,
      overflow: "hidden",
      backgroundColor: "#1a1a1a",
      color: "#fff",
      //  maxWidth: 600,
      margin: "0 auto",
      position: "relative",
      width: "800px",
      maxWidth: "800px",
      padding: "0px",
      [theme.breakpoints.down("md")]: {
        padding: theme.spacing(2),
        marginLeft: "auto",
        marginRight: "auto",
        borderRadius: 16,
      },
      [theme.breakpoints.down("sm")]: {
        padding: "12px",
        borderRadius: 12,
        width: "300px",
      },
      [theme.breakpoints.down("xs")]: {
        padding: theme.spacing(1),
      },
      [theme.breakpoints.up("lg")]: {},
      "&.MyFeed": {
        border: "1px solid #363636",
        borderRadius: 16,
        overflow: "hidden",
        backgroundColor: "#1a1a1a",
        color: "#fff",
        //   width: "100%",
        //   maxWidth: 600,
        margin: "0 auto",
        width: "800px",
        maxWidth: "800px",
        padding: "10px",
        [theme.breakpoints.down("md")]: {
          marginLeft: "auto",
          marginRight: "auto",
          borderRadius: 16,
        },
        [theme.breakpoints.down("sm")]: {
          borderRadius: 12,
          width: "380px",
          maxWidth: "380px",
        },
        [theme.breakpoints.down("xs")]: {},
        [theme.breakpoints.up("lg")]: {
          maxWidth: "60vw",
        },
      },
      "&.explore": {
        border: "none",
        borderRadius: 20,
        backgroundColor: "#000000",
        display: "flex",
        flexDirection: "column",
        padding: "0px",
        marginLeft: "none",
        marginRight: "none",
        overflow: "visible",
        maxWidth: 600,
        [theme.breakpoints.down("md")]: {
          maxWidth: 500,
        },
        [theme.breakpoints.down("sm")]: {},
        [theme.breakpoints.down("xs")]: {
          maxWidth: 330,
          marginLeft: "0px",
          marginRight: "0px",
        },
        [theme.breakpoints.up("lg")]: {},
      },
    },
    mediaHelpexplore: {
      width: "500px",
      // display: "flex",
      justifyContent: "center",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        width: "340px",
        maxWidth: "340px",
      },
    },
    media_imgHelphelp: {
      width: "100%",
      borderRadius: theme.shape.borderRadius,
      //   height: "500px",
      objectFit: "contain",
      height: "610px",
      maxHeight: "610px",
      [theme.breakpoints.down("md")]: {
        height: "400px",
      },
      [theme.breakpoints.down("sm")]: {
        height: "auto",
        maxHeight: "350px",
      },
      "&.MyFeed": {
        height: "610px",
        maxHeight: "610px",
        objectFit: "contain",

        [theme.breakpoints.down("md")]: {},
        [theme.breakpoints.down("sm")]: {
          //    objectFit: "contain",
          height: "410px",
          maxHeight: "410px",
        },
      },
      "&.explore": {
        height: "610px",
        maxHeight: "610px",
        //  height: "710px",
        //  maxWidth: "450px",
        //  maxHeight: "710px",
        // objectFit: "visibility", // ⬅️ замість cover
        borderRadius: 22,
        [theme.breakpoints.down("md")]: {
          height: "510px",
          maxHeight: "510px",
        },
        [theme.breakpoints.down("sm")]: {
          height: "480px",
          maxHeight: "480px",
        },
        [theme.breakpoints.down("xs")]: {},
        [theme.breakpoints.up("lg")]: {},
      },
    },
    cardHeaderNoPadding: {
      padding: 0,
    },
    sliderWrapper: {
      maxWidth: "700px",
      width: "100%",
      margin: "0 auto",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "300px",
      },
    },
    sliderWrapperr: {
      maxWidth: "600px",
      width: "100%",
      margin: "0 auto",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "300px",
      },
    },
    mediaContainerhelp: {
      maxWidth: "100%",
      margin: "0 auto",
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down("md")]: {
        //     maxHeight: 400,
      },
      [theme.breakpoints.down("sm")]: {
        marginBottom: theme.spacing(1),
      },
      "&.My Subscription": {
        maxHeight: 500,
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
          maxHeight: 400,
        },
        [theme.breakpoints.down("sm")]: {},
      },
      "&.explore": {
        height: "100%",
        width: "100%",
        flexGrow: 1,
        // display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // overflow: "hidden",
        [theme.breakpoints.down("md")]: {},
        [theme.breakpoints.down("sm")]: {},
        [theme.breakpoints.down("xs")]: {},
        [theme.breakpoints.up("lg")]: {},
      },
    },
    menu: {
      "& .MuiPaper-root": {
        backgroundColor: "#2a2a2a",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
        // height: '53px',
      },
      "& .MuiList-root": {
        padding: "12px",
      },
      "& .MuiMenu-list": {
        padding: "12px",
      },
      "& .MuiList-padding": {
        padding: "12px",
      },
      "& .MuiListItem-root.Mui-disabled": {
        opacity: 1,
      },
    },
    menuItem: {
      color: "#ffffff",
      fontSize: "14px",
      padding: theme.spacing(1, 2),
      "&:hover": {
        color: "#f06ec4",
      },
      "&:not(:last-child)": {
        borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
      },
    },
    menuItemTip: {
      backgroundColor: "#FFFFFF08",
      padding: "11.25px 17.25px",
      color: "#ffffff",
      fontSize: "20px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      borderRadius: "6px",
      "&:hover": {
        backgroundColor: "#FFFFFF12",
      },
    },
    menuDivider: {
      borderTop: "1px solid #FFFFFF08",
      margin: "12px 0",
      padding: 0,
      height: "1px",
      minHeight: "1px",
      cursor: "default",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    menuItemReport: {
      backgroundColor: "#FFFFFF08",
      color: "#FD3C84",
      fontSize: "20px",
      padding: "11.25px 17.25px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginTop: "6px",
      borderRadius: "6px",
      "&:hover": {
        backgroundColor: "rgba(255, 69, 116, 0.1)",
      },
      "& svg": {
        color: "#FF4574",
      },
    },
    menuItemFollow: {
      backgroundColor: "#FFFFFF08",
      color: "#ffffff",
      fontSize: "14px",
      padding: "11.25px 17.25px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      borderRadius: "6px",
      "&:hover": {
        color: "#f06ec4",
      },
    },
    sliderArrow: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 10,
      width: 40,
      height: 40,
      borderRadius: "50%",
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 1)",
        transform: "translateY(-50%) scale(1.1)",
      },
      [theme.breakpoints.down("sm")]: {
        width: 32,
        height: 32,
      },
    },
    sliderArrowPrev: {
      left: theme.spacing(2),
      [theme.breakpoints.down("sm")]: {
        left: theme.spacing(1),
      },
    },
    sliderArrowNext: {
      right: theme.spacing(2),
      [theme.breakpoints.down("sm")]: {
        right: theme.spacing(1),
      },
    },
  })
);
